import { z } from 'zod';

export const ContactsSchema = z.object({
  contacts: z.array(z.any()),
  contacts_count: z.number(),
});

// TypeScript Interfaces
export type ContactsResponse = z.infer<typeof ContactsSchema>;
